import { ActionType } from './actions';
import { initialState, IState } from './state';

export const reducer = (state: IState = initialState, { type, payload }: { type: ActionType; payload?: any }): IState => {
  switch (type) {
    case ActionType.SIGN_IN_SUCCESS:
      return {
        ...state,
        authenticated: true,
        session: payload.session || {},
        role: payload.session?.['custom:role'],
        companyUserId: payload.session?.['custom:companyuserid'],
        companyWorkerId: payload.session?.['custom:companyworkerid'],
        currentCompanyId: payload.session?.['custom:currentcompanyid'],
        isFcaUser: payload.session?.['custom:currentcompanyid'] === 'ffffffff-ffff-ffff-ffff-ffffffffffff',
        isAdmin: payload.session?.['custom:isadmin'] === 'True',
        isOSR: payload.session?.['custom:isosr'] === 'True',
        isSuperAdmin: payload.session?.['custom:issuperadmin'] === 'True',
        isAdminOnAnyProject: payload?.session?.['custom:isadmininanyproject'] === 'True',
      };
    case ActionType.FETCH_USER_PERMISSIONS_SUCCESS: {
      return {
        ...state,
        isProjectAdmin: payload.isProjectAdmin,
        session: {
          ...state.session,
          isProjectAdmin: payload.isProjectAdmin,
          permissions: payload.perimissions,
        },
      };
    }
    case ActionType.SIGN_OUT_SUCCESS:
      return { ...state, authenticated: false };
    case ActionType.RECOVER_SESSION_DONE:
      return { ...state, sessionChecked: true };
    case ActionType.SET_CLIENT_ID:
      if (payload.value && payload.value.length > 0) {
        localStorage.setItem('auth-client-id', payload.value);
      } else {
        localStorage.removeItem('auth-client-id');
      }
      return { ...state, clientId: payload.value };
    case ActionType.SET_ORIGINAL_COMPANY_ID:
      return { ...state, originalCompanyId: payload.value };
    case ActionType.SET_USER_NAME:
      return { ...state, userName: payload.value };
    default:
      return state;
  }
};
